/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import Vuex from 'vuex';

// Store functionality
// import makeActions from './actions';
import getters from './getters';
import modules from './modules';
import actions from './actions';
import mutations from './mutations';
import state from './state';

// import makeBibleStudyPlansStore from './modules/BibleStudyPlans/index';
import BibleStudies from './modules/BibleStudies/index';
import BibleStudyPlans from './modules/BibleStudyPlans/index';
import Meditations from './modules/Meditations/index';
import DepthChart from './modules/DepthChart/index';
import People from './modules/People/index';
import Discipleship from './modules/Discipleship/index';
import VacationDates from './modules/VacationDates/index';

Vue.use(Vuex);

// Create a new store

// const makeStore = (serviceContainer) => {
//     const actions = makeActions(serviceContainer);
//     const bibleStudyPlans = makeBibleStudyPlansStore(serviceContainer);

//     return new Vuex.Store({
//         actions,
//         getters,
//         mutations,
//         state,
//         modules: {
//             BibleStudyPlans: bibleStudyPlans
//         }
//     });
// };

// export default makeStore;
const store = new Vuex.Store({
    actions,
    getters,
    mutations,
    state,
    modules: {
        BibleStudies,
        BibleStudyPlans,
        Meditations,
        DepthChart,
        People,
        Discipleship,
        VacationDates
    }
});

export default store;
